import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Grid,
  Typography,
  IconButton,
  TextField,
  FormControl,
  Select,
  MenuItem,
  Button,
  InputAdornment,
  Pagination,
  Autocomplete,
   CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import MedicalServicesOutlinedIcon from "@mui/icons-material/MedicalServicesOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ClinicalDocumentationQuery from "./ClinicalDocumentationQuery";
import { useDispatch, useSelector } from "react-redux";
import { getCdqTemplate, setCdqTemplatesPage, getCdqTemplateDetails, getClinicianData } from "../Redux/EpisodeStatusSlice";

const GenerateCDQ = ({ open, onClose,episodeList, onCdqSend,isSendingCDQ  }) => {
    const [openQuery, setOpenQuery] = useState(false);
    const [selectedTemplate, setSelectedTemplate] = useState("");
    const [clinician, setClinician] = useState("");
    const [clinicianEmail, setClinicianEmail] = useState("");
    const [specialtyService,setSpecialtyService] = useState("")
    const [templateSearch, setTemplateSearch] = useState("");
    const [searchInput, setSearchInput] = useState("");
const [templateOpen, setTemplateOpen] = useState(false);
const [clinicianOpen, setClinicianOpen] = useState(false);
    const dispatch = useDispatch()
    const {
  cdqTemplates,
  cdqTemplatesLoading,
  cdqTemplatesTotalCount,
  cdqTemplatesPageNumber,
  cdqTemplatesPageSize,
   cdqTemplateDetails,
  cdqTemplateDetailsLoading,
  cdqRequest,
   clinicians,
  cliniciansLoading,
  cliniciansPageNumber,
  cliniciansPageSize,
  cliniciansHasMore,
} = useSelector(
  (state) => state.episodeStatus
);



     const selectedEpisode = episodeList?.selectedEpisode;
      const mrn = selectedEpisode?.medical_record_number ?? "-";

  const episodeIdentifier =
    selectedEpisode?.episode_identifier ?? "-";

  const admissionDate =
    selectedEpisode?.admission_date ?? "-";

  const separationDate =
    selectedEpisode?.separation_date ?? "-";

  const lengthOfStay =
    selectedEpisode?.length_of_stay ?? "-";

  const speciality =
    selectedEpisode?.speciality ?? "-";

   useEffect(() => {
  if (!open) return;

  dispatch(
    getCdqTemplate({
      page_number: cdqTemplatesPageNumber,
      page_size: cdqTemplatesPageSize,
      search_text: templateSearch,
    })
  );
}, [
  open,
  cdqTemplatesPageNumber,
  cdqTemplatesPageSize,
  templateSearch,
  dispatch,
]);
 useEffect(() => {
    if (!open) {
      setOpenQuery(false);
      setSelectedTemplate("");
      setClinician("");
      setClinicianEmail("");
      setSpecialtyService("");
      setTemplateSearch("");
      setSearchInput("");
      setTemplateOpen(false);
    }
  }, [open]);
const handleContinue = async () => {
  if (!selectedTemplate) {
    return;
  }

  const payload = {
    template_id: Number(selectedTemplate),
    clinician_name: clinician,
    email: clinicianEmail,
    specialty: specialtyService,
  };

  try {
    await dispatch(
      getCdqTemplateDetails(payload)
    ).unwrap();

    setOpenQuery(true);
  } catch (error) {
    console.error(
      "Failed to get CDQ template details:",
      error
    );
  }
};
const handleClinicianScroll = (event) => {
  const listboxNode = event.currentTarget;

  const reachedBottom =
    listboxNode.scrollTop +
      listboxNode.clientHeight >=
    listboxNode.scrollHeight - 20;

  if (
    reachedBottom &&
    cliniciansHasMore &&
    !cliniciansLoading
  ) {
    dispatch(
      getClinicianData({
        search_text: clinician.trim(),
        page_number: cliniciansPageNumber + 1,
        page_size: cliniciansPageSize,
      })
    );
  }
};
const handleClinicianSearch = (value) => {
  setClinician(value);

  if (!value?.trim()) {
    setClinicianEmail("");
    setSpecialtyService("");
    return;
  }

  dispatch(
    getClinicianData({
      search_text: value.trim(),
      page_number: 1,
      page_size: 5,
    })
  );
};
const handleClose = () => {
 setClinician("");
  setClinicianEmail("");
  setSpecialtyService("");
  setSelectedTemplate("");
  setTemplateSearch("");
  setSearchInput("");
  setTemplateOpen(false);
  setOpenQuery(false);

  if (typeof onClose === "function") {
    onClose();
  }
};

useEffect(() => {
  if (!clinician?.trim() || !Array.isArray(clinicians) || clinicians.length === 0) {
    return;
  }

  const typedName = clinician.trim().toLowerCase();

  const matchedClinician = clinicians.find(
    (item) =>
      item?.clinician_name?.trim().toLowerCase() === typedName
  );

  if (matchedClinician) {
    setClinicianEmail(matchedClinician.email || "");
    setSpecialtyService(matchedClinician.specialty || "");
  }
}, [clinician, clinicians]);

// const handleCloseGenerateCDQ = () => {
//   setOpenQuery(false)
//   setClinician("");
//   setClinicianEmail("");
//   setSpecialtyService("");
//   setSelectedTemplate("");
//   setTemplateSearch("");
//   setSearchInput("");
//   setTemplateOpen(false);
//   setOpenQuery(false);

//   onClose();
// };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          width: "600px",
          maxWidth: "600px",
          borderRadius: "12px",
          overflow: "hidden",
        },
      }}
    >
      {/* Header */}
      <DialogTitle
        sx={{
          bgcolor: "#E3F4FF",
          borderBottom: "2px solid #2196F3",
          px: 4,
          py: 2.5,
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 600,
              fontFamily: "Inter",
              color: "#101828",
            }}
          >
            Generate CDQ
          </Typography>

          <IconButton onClick={handleClose} size="small" sx={{ mr: -1 }}>
            <CloseIcon sx={{ fontSize: 22, color: "#101828" }} />
          </IconButton>
        </Box>
      </DialogTitle>

      {/* Content */}
      <DialogContent sx={{ px: 2, py: 2.5 }}>
        <Typography
          sx={{
            color: "#004881",
            fontWeight: 700,
            fontSize: "11px",
            letterSpacing: "0.6px",
            mb: 3,
            mt: 2,
          }}
        >
          EPISODE INFORMATION
        </Typography>

        {/* Row of THREE items — equal columns, evenly aligned */}
        <Box
  sx={{
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    columnGap: 3,
    rowGap: 3,
  }}
>
  {/* ================= ROW 1 ================= */}

  <Box>
    <Typography sx={{ fontSize: "11px", color: "#667085", mb: 0.6 }}>
      MRN
    </Typography>

    <Typography
      sx={{
        fontSize: "11px",
        fontWeight: 600,
        color: "#101828",
      }}
    >
      {mrn}
    </Typography>
  </Box>

  <Box>
    <Typography sx={{ fontSize: "11px", color: "#667085", mb: 0.6 }}>
      Episode ID
    </Typography>

    <Typography
      sx={{
        fontSize: "11px",
        fontWeight: 600,
        color: "#101828",
      }}
    >
      {episodeIdentifier}
    </Typography>
  </Box>

  {/* <Box>
    <Typography sx={{ fontSize: "11px", color: "#667085", mb: 0.6 }}>
      Facility / Site
    </Typography>

    <Typography
      sx={{
        fontSize: "11px",
        fontWeight: 700,
        color: "#101828",
      }}
    >
      North Metro Hospital
    </Typography>
  </Box> */}


  {/* ================= ROW 2 ================= */}

  <Box>
    <Typography sx={{ fontSize: "11px", color: "#667085", mb: 0.6 }}>
      Admission Date
    </Typography>

    <Typography
      sx={{
        fontSize: "11px",
        fontWeight: 600,
        color: "#101828",
      }}
    >
      {admissionDate}
    </Typography>
  </Box>

  <Box>
    <Typography sx={{ fontSize: "11px", color: "#667085", mb: 0.6 }}>
      Separation Date
    </Typography>

    <Typography
      sx={{
        fontSize: "11px",
        fontWeight: 600,
        color: "#101828",
      }}
    >
      {separationDate}
    </Typography>
  </Box>

  <Box>
    <Typography sx={{ fontSize: "11px", color: "#667085", mb: 0.6 }}>
      Length of Stay (LOS)
    </Typography>

    <Typography
      sx={{
        fontSize: "11px",
        fontWeight: 600,
        color: "#101828",
      }}
    >
      {lengthOfStay} Days
    </Typography>
  </Box>


  {/* ================= ROW 3 ================= */}

  {/* ================= CLINICIAN ================= */}

<Box sx={{ gridColumn: "1 / -1" }}>
  <Typography
    sx={{
      fontSize: "11px",
      color: "#344054",
      mb: 0.8,
      fontWeight: 500,
    }}
  >
    Clinician
    <Box
      component="span"
      sx={{
        color: "#D92D20",
        ml: 0.4,
      }}
    >
      *
    </Box>
  </Typography>

  <Autocomplete
    fullWidth
    freeSolo
     options={clinician.trim() ? clinicians : []}
    loading={cliniciansLoading}
    open={clinicianOpen}
    onOpen={() => {
      if (clinicians.length > 0) {
        setClinicianOpen(true);
      }
    }}
    onClose={() => setClinicianOpen(false)}
    value={
      clinicians.find(
        (item) => item.clinician_name === clinician
      ) || null
    }
    inputValue={clinician}
    getOptionLabel={(option) =>
      typeof option === "string"
        ? option
        : option?.clinician_name || ""
    }
    isOptionEqualToValue={(option, value) =>
      option.clinician_id === value?.clinician_id
    }
    // filterOptions={(options) => options}
    filterOptions={(options, { inputValue }) => {
    const search = inputValue.trim().toLowerCase();

    if (!search) return options;

    return options.filter((option) =>
      option?.clinician_name?.toLowerCase().includes(search)
    );
  }}
    onInputChange={(_, value, reason) => {
     if (reason === "input") {
    handleClinicianSearch(value);

    if (value.trim()) {
      setClinicianOpen(true);
    } else {
      setClinicianOpen(false);
    }
  }


      if (reason === "clear") {
        setClinician("");
        setClinicianEmail("");
        setSpecialtyService("");
        setClinicianOpen(false);
      }
    }}
    onChange={(_, selectedClinician) => {
      if (!selectedClinician) {
        setClinician("");
        setClinicianEmail("");
        setSpecialtyService("");
        return;
      }

      setClinician(
        selectedClinician.clinician_name || ""
      );

      setClinicianEmail(
        selectedClinician.email || ""
      );

      setSpecialtyService(
        selectedClinician.specialty || ""
      );

      setClinicianOpen(false);
    }}
    ListboxProps={{
      onScroll: handleClinicianScroll,
      sx: {
        maxHeight: "230px",
        overflowY: "auto",
        p: 0,
      },
    }}
    renderOption={(props, option) => (
      <Box
        component="li"
        {...props}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.2,
          px: "12px !important",
          py: "9px !important",
          minHeight: "54px !important",

          "&:hover": {
            bgcolor: "#F5F9FC",
          },
        }}
      >
        <Box
          sx={{
            width: 30,
            height: 30,
            borderRadius: "50%",
            bgcolor: "#E8F3FB",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <PersonOutlineOutlinedIcon
            sx={{
              fontSize: 17,
              color: "#0057A8",
            }}
          />
        </Box>

        <Box sx={{ minWidth: 0 }}>
          <Typography
            sx={{
              fontSize: "11px",
              fontWeight: 600,
              color: "#101828",
            }}
          >
            {option.clinician_name}
          </Typography>

          <Typography
            sx={{
              fontSize: "10px",
              color: "#667085",
              mt: 0.3,
            }}
          >
            {option.specialty || "Specialty not available"}
          </Typography>

          <Typography
            sx={{
              fontSize: "10px",
              color: "#98A2B3",
              mt: 0.2,
            }}
          >
            {option.email}
          </Typography>
        </Box>
      </Box>
    )}
    noOptionsText={
      cliniciansLoading
        ? "Searching clinicians..."
        : "No clinicians found"
    }
    renderInput={(params) => (
      <TextField
        {...params}
        fullWidth
        size="small"
        placeholder="Search clinician by name"
        InputProps={{
          ...params.InputProps,

          endAdornment: (
            <>
              {cliniciansLoading && (
                <CircularProgress
                  color="inherit"
                  size={14}
                  sx={{ mr: 1 }}
                />
              )}

              {params.InputProps.endAdornment}
            </>
          ),

          sx: {
            height: "36px",
            fontSize: "11px",
            bgcolor: "#F8FAFC",
            borderRadius: "5px",

            "& fieldset": {
              borderColor: "#D0D5DD",
            },

            "&:hover fieldset": {
              borderColor: "#98A2B3",
            },

            "&.Mui-focused fieldset": {
              borderColor: "#003B75",
            },
          },
        }}
      />
    )}
  />

  {/* Selected clinician information */}

  {/* {clinician && (
    <Box
      sx={{
        mt: 1.2,
        border: "1px solid #D9E8F5",
        bgcolor: "#F7FBFF",
        borderRadius: "6px",
        px: 1.5,
        py: 1.2,
      }}
    >
      <Typography
        sx={{
          fontSize: "9px",
          fontWeight: 700,
          color: "#667085",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
          mb: 1,
        }}
      >
        Selected Clinician
      </Typography>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          columnGap: 2,
          rowGap: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <PersonOutlineOutlinedIcon
            sx={{
              fontSize: 16,
              color: "#0057A8",
            }}
          />

          <Box>
            <Typography
              sx={{
                fontSize: "9px",
                color: "#98A2B3",
              }}
            >
              Clinician
            </Typography>

            <Typography
              sx={{
                fontSize: "11px",
                fontWeight: 600,
                color: "#101828",
              }}
            >
              {clinician || "-"}
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <MedicalServicesOutlinedIcon
            sx={{
              fontSize: 16,
              color: "#0057A8",
            }}
          />

          <Box>
            <Typography
              sx={{
                fontSize: "9px",
                color: "#98A2B3",
              }}
            >
              Specialty / Service
            </Typography>

            <Typography
              sx={{
                fontSize: "11px",
                fontWeight: 600,
                color: "#101828",
              }}
            >
              {specialtyService || "-"}
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            gridColumn: "1 / -1",
          }}
        >
          <EmailOutlinedIcon
            sx={{
              fontSize: 16,
              color: "#0057A8",
            }}
          />

          <Box sx={{ minWidth: 0 }}>
            <Typography
              sx={{
                fontSize: "9px",
                color: "#98A2B3",
              }}
            >
              Clinician Email
            </Typography>

            <Typography
              sx={{
                fontSize: "11px",
                fontWeight: 500,
                color: "#101828",
                wordBreak: "break-word",
              }}
            >
              {clinicianEmail || "-"}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  )} */}
</Box>

  <Box>
  <Typography
    sx={{
      fontSize: "11px",
      color: "#344054",
      mb: 0.8,
    }}
  >
    Specialty / Service
  </Typography>

  <TextField
    fullWidth
    size="small"
    value={specialtyService}
    onChange={(e) => setSpecialtyService(e.target.value)}
    placeholder="Specialty/Service"
    InputProps={{
      sx: {
        height: "32px",
        fontSize: "11px",
        bgcolor: "#F8FAFC",
        borderRadius: "4px",
        "& fieldset": {
          borderColor: "#D0D5DD",
        },
      },
    }}
  />
</Box>


  {/* ================= ROW 4 ================= */}

  <Box sx={{ gridColumn: "span 2" }}>
    <Typography sx={{ fontSize: "11px", color: "#344054", mb: 0.8 }}>
      Clinician Email
    </Typography>

    <TextField
      fullWidth
      size="small"
      type="email"
      value={clinicianEmail}
      onChange={(e) => setClinicianEmail(e.target.value)}
      placeholder="Enter Clinician Email"
      InputProps={{
        sx: {
          height: "32px",
          fontSize: "11px",
          bgcolor: "#F8FAFC",
          borderRadius: "4px",

          "& fieldset": {
            borderColor: "#D0D5DD",
          },
        },

        endAdornment: (
          <InputAdornment position="end">
            <EditOutlinedIcon
              sx={{
                fontSize: 13,
                color: "#667085",
              }}
            />
          </InputAdornment>
        ),
      }}
    />
  </Box>


  {/* ================= CDQ TEMPLATE ================= */}

  <Box
    sx={{
      gridColumn: "1 / -1",
      bgcolor: "#E8F5FF",
      border: "1px solid #B9D8F5",
      borderRadius: "6px",
      p: 2,
      mt: 0.5,
    }}
  >
    <Typography
      sx={{
        fontSize: "11px",
        fontWeight: 700,
        color: "#101828",
        mb: 1.2,
      }}
    >
      CDQ Template

      <Box
        component="span"
        sx={{
          color: "#D92D20",
          ml: 0.5,
        }}
      >
        *
      </Box>
    </Typography>

     <FormControl fullWidth size="small">
 <Box sx={{ position: "relative" }}>
 <Autocomplete
  open={templateOpen}
  onOpen={() => setTemplateOpen(true)}
  onClose={(_, reason) => {
    // Don't close when clicking pagination
    if (reason === "blur") return;
    setTemplateOpen(false);
  }}
  options={cdqTemplates}
  value={
    cdqTemplates.find(
      (item) =>
        item.cdq_templates_id === Number(selectedTemplate)
    ) || null
  }
  getOptionLabel={(option) =>
    option?.display_name || ""
  }
  isOptionEqualToValue={(option, value) =>
    option.cdq_templates_id === value.cdq_templates_id
  }
  onChange={(_, value) => {
    setSelectedTemplate(
      value?.cdq_templates_id || ""
    );
  }}
  loading={cdqTemplatesLoading}
  filterOptions={(options) => options}
  popupIcon={<KeyboardArrowDownIcon />}

  // IMPORTANT: allow popup to escape DialogContent
  disablePortal={false}

  ListboxProps={{
    onScroll: handleClinicianScroll,
    sx: {
      maxHeight: "230px",
      overflowY: "auto",
      p: 0,

      "& .MuiAutocomplete-option": {
        minHeight: "36px",
      },
    },
  }}

  slotProps={{
    popper: {
      placement: "bottom-start",

      modifiers: [
        {
          name: "flip",
          enabled: false,
        },
        {
          name: "preventOverflow",
          options: {
            boundary: "viewport",
          },
        },
      ],

      sx: {
        zIndex: 1500,
      },
    },
  }}

  PaperComponent={(paperProps) => (
  <Box
    {...paperProps}
    sx={{
      bgcolor: "#fff",
      border: "1px solid #D0D5DD",
      borderRadius: "6px",
      boxShadow:
        "0px 4px 12px rgba(16, 24, 40, 0.15)",
      overflow: "hidden",
    }}
  >
    {/* Template list */}
    <Box
      sx={{
        position: "relative",
        minHeight: "100px",
      }}
    >
      {paperProps.children}

      {/* Loading overlay */}
      {cdqTemplatesLoading && (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            bgcolor: "rgba(255,255,255,0.75)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: 0.8,
            zIndex: 2,
          }}
        >
          <CircularProgress
            size={22}
            thickness={4}
            sx={{
              color: "#003B75",
            }}
          />

          <Typography
            sx={{
              fontSize: "11px",
              color: "#667085",
            }}
          >
            Loading templates...
          </Typography>
        </Box>
      )}
    </Box>

    {/* Pagination */}
    {cdqTemplatesTotalCount > cdqTemplatesPageSize && (
      <Box
        sx={{
          borderTop: "1px solid #EAECF0",
          bgcolor: "#fff",
          px: 1,
          py: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        onMouseDown={(e) => {
          e.preventDefault();
        }}
      >
        <Pagination
          count={Math.ceil(
            cdqTemplatesTotalCount /
              cdqTemplatesPageSize
          )}
          page={Number(
            cdqTemplatesPageNumber || 1
          )}
          disabled={cdqTemplatesLoading}
          onChange={(_, page) => {
            dispatch(
              setCdqTemplatesPage(page)
            );
          }}
          size="small"
          siblingCount={0}
          boundaryCount={1}
          sx={{
            "& .MuiPaginationItem-root": {
              minWidth: "26px",
              height: "26px",
              fontSize: "10px",
              color: "#344054",
            },

            "& .MuiPaginationItem-root.Mui-selected": {
              bgcolor: "#003B75",
              color: "#fff",
            },

            "& .MuiPaginationItem-root.Mui-selected:hover": {
              bgcolor: "#003B75",
            },
          }}
        />
      </Box>
    )}
  </Box>
)}

  renderInput={(params) => (
    <TextField
      {...params}
      placeholder="Select CDQ template"
      size="small"
      value={searchInput}
      onChange={(e) => {
        const value = e.target.value;

        setSearchInput(value);
        setTemplateSearch(value);

        // Reset pagination when searching
        if (cdqTemplatesPageNumber !== 1) {
          dispatch(setCdqTemplatesPage(1));
        }
      }}
      InputProps={{
        ...params.InputProps,
        sx: {
          height: "32px",
          fontSize: "11px",
          bgcolor: "#fff",
          borderRadius: "4px",

          "& fieldset": {
            borderColor: "#CBD5E1",
          },

          "&:hover fieldset": {
            borderColor: "#98A2B3",
          },

          "&.Mui-focused fieldset": {
            borderColor: "#003B75",
          },
        },
      }}
    />
  )}

  renderOption={(props, option) => (
    <Box
      component="li"
      {...props}
      sx={{
        minHeight: "36px !important",
        px: "12px !important",
        fontSize: "11px",
        color: "#344054",

        "&:hover": {
          bgcolor: "#F2F4F7",
        },
      }}
    >
      {option.display_name}
    </Box>
  )}

  noOptionsText={
    cdqTemplatesLoading
      ? "Loading templates..."
      : "No templates found"
  }
/>

</Box>
</FormControl>

<Typography
      sx={{
        mt: 1,
        fontSize: "10px",
        color: "#667085",
        lineHeight: 1.5,
      }}
    >
      Please Select A Valid Template To Proceed With Clinical
      Documentation Quality Generation.
    </Typography>
  </Box>
</Box>
      </DialogContent>

      {/* Footer */}
      <DialogActions
        sx={{
          bgcolor: "#F5F7FB",
          borderTop: "1px solid #EAECF0",
          px: 4,
          py: 2.5,
          gap: 1.5,
        }}
      >
        <Button
          onClick={handleClose}
          sx={{
            color: "#0057A8",
            textTransform: "none",
            fontWeight: 600,
            fontSize: "14px",
          }}
        >
          Cancel
        </Button>

       <Button
  variant="contained"
  onClick={handleContinue}
  disabled={
    !selectedTemplate ||
    cdqTemplateDetailsLoading
  }
  endIcon={
    cdqTemplateDetailsLoading ? (
      <CircularProgress
        size={16}
        sx={{ color: "#fff" }}
      />
    ) : (
      <ArrowForwardIcon sx={{ fontSize: 16 }} />
    )
  }
  sx={{
    bgcolor: "#003B75",
    px: 3.5,
    py: 1.1,
    textTransform: "none",
    fontWeight: 600,
    fontSize: "14px",
    borderRadius: "6px",

    "&:hover": {
      bgcolor: "#002B55",
    },

    "&.Mui-disabled": {
      bgcolor: "#98A2B3",
      color: "#fff",
    },
  }}
>
  {cdqTemplateDetailsLoading
    ? "Loading..."
    : "Continue"}
</Button>
        <ClinicalDocumentationQuery
       open={openQuery}
  onClose={() => setOpenQuery(false)}
   setSpecialtyService = {setSpecialtyService}
   setClinicianEmail = {setClinicianEmail}
   setClinician = {setClinician}
  // onClose={handleCloseGenerateCDQ}
  cdqTemplateDetails={cdqTemplateDetails}
  specialtyService={specialtyService}
  clinician= {clinician}
  selectedEpisode = {selectedEpisode}
  onSendQuery={onCdqSend}
  isSendingCDQ={isSendingCDQ}
/>
      </DialogActions>
    </Dialog>
  );
};

export default GenerateCDQ;